<template>
  <div class="cell large-12 xxlarge-6">
    <div class="card">
      <div class="grid-x card-header">
        <div class="cell auto">
          <router-link :to="{ name: 'DashboardPageFailedOppgjor'}">
            <h3 class="icon-heading small">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-invoice"></use></svg></span> Oppgjor som har feilet
              <span v-if="total !== null" class="opacity-60">({{total}})</span>
            </h3>
          </router-link>
        </div>
      </div>

      <table-failed-oppgjor v-on:tableLoaded="tableLoaded" :limit="6" :large="false" />
    </div>
  </div>
</template>

<script>
import TableFailedOppgjor from './TableFailedOppgjor'

export default {
  name: 'WidgetFailedOppgjor',
  components: {
    TableFailedOppgjor
  },
  data () {
    return {
      total: null
    }
  },
  created () {
  },
  methods: {
    tableLoaded: function (data) {
      this.total = data.total
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/WidgetFailedOppgjor.vue